module.exports = __webpack_public_path__ + "static/media/browser-coconote-3.b6d93009.png";